module.exports = __webpack_public_path__ + "static/assets/3954a4b8029afa558b84c060f7bb00ef.png";